
import { IErrorLog } from '@/types/models';
import { defineComponent } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/logsError';

interface IForm {
  dateFrom: string;
  dateTo: string;
  keyword: string;
  currentPage: number;
  offset: number;
  limit: number;
}

interface IState {
  items: IErrorLog[];
  count: number;
  formInline: IForm;
}

export default defineComponent({
  data() {
    return {
      items: [],
      count: 0,
      formInline: {
        dateFrom: '',
        dateTo: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: 30,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.items = res.items;
        this.count = res.count;
      });
    },

    apiDelete() {
      api.delete((res) => {
        if (!res) return;

        this.items = [];
        this.count = 0;
      });
    },

    btnDeleteClick() {
      utils.alertDelete(
        {
          title: '清空系统错误日志',
          text: '此操作将会清空系统错误日志，确定吗？',
          button: '清 空',
        },
        () => {
          this.apiDelete();
        },
      );
    },

    btnLogView(logId: number) {
      utils.pageOpen('error', {
        logId,
      });
    },

    btnSearchClick() {
      this.formInline.currentPage = 1;
      this.formInline.offset = 0;
      this.formInline.limit = 30;

      api.get(this.formInline, (res) => {
        this.items = res.items;
        this.count = res.count;
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      api.get(this.formInline, (res) => {
        this.items = res.items;
        this.count = res.count;
        utils.scrollTop();
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
